import Modal from "/WebInterface/new-ui/modules/modal.js";
import HashListener from "/WebInterface/new-ui/modules/hash-listener.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import reportAProblemTemplate from "./template.js";
import { reportAProblem } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import store from "/WebInterface/new-ui/store/index.js";

export const initReportAProblem = ({ paths }) => {
  const reportAProblemDialog = new Modal({
    title: "Report A Problem",
    body: reportAProblemTemplate({}),
    uniqueId: "report-a-problem-modal",
    buttons: [
      {
        label: "cancel",
        close: true,
        classes: ["secondary-button", "is-bordered", "mr-3"],
        onClick: () => {},
      },
      {
        label: "report",
        classes: ["primary-button", "mr-3"],
        onClick: () => {
          const hashListener = new HashListener({});

          const name = store?.userInfo?.username;
          const message = utils.encodeURILocal(
            _$("#reportAProblemTextArea").val()
          );
          const path =
            utils.encodeURILocal(
              hashListener.getPath().toString().replace("#", "")
            ) || "/";
          const host = window.location.host;
          const browser = window.navigator.userAgent;
          const browser_version = window.navigator.appVersion;
          const local_time = new Date().getTime();
          const now = new Date();
          const local_time_formatted = `${flatpickr.formatDate(
            now,
            utils.getApiDateFormat()
          )} ${flatpickr.formatDate(now, utils.getApiTimeFormat())}`;
          const timezone_offset = new Date().getTimezoneOffset() / 60;
          const window_size = window.innerWidth + "x" + window.innerHeight;
          const resolution = window.screen.width + "x" + window.screen.height;

          reportAProblem({
            selected_item: paths,
            name,
            message,
            path,
            host,
            browser,
            browser_version,
            local_time,
            local_time_formatted,
            timezone_offset,
            window_size,
            resolution,
          })
            .then((result) => {
              const resp = result.commandResult?.response;
              growl("Problem Reported", resp, 5000);
              reportAProblemDialog.hide(true);
            })
            .catch((error) => {
              growl("", error, 5000, true);
            });
        },
      },
    ],
  });
};
